import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import { PRACTICE_AREAS } from "../data/content";
import { ArrowUpRight } from "lucide-react";

export default function Practice() {
  const { t, lang } = useI18n();
  return (
    <div data-testid="practice-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
      <div className="grid lg:grid-cols-12 gap-12 mb-16">
        <div className="lg:col-span-5">
          <p className="eyebrow">{t.nav.practice}</p>
          <h1 className="font-display text-5xl lg:text-6xl mt-4 leading-[1.0] tracking-tight">
            {lang === "ar" ? "ست تخصصات. شراكة واحدة." : "Six disciplines. One partnership."}
          </h1>
        </div>
        <div className="lg:col-span-7 lg:pt-3">
          <p className="text-lg text-slate-600 leading-relaxed">
            {lang === "ar"
              ? "نشكل فرقًا حول كل قضية مع تعيين كبار المحامين."
              : "We staff every matter with senior lawyers in lead roles. The team is shaped to the matter — never the reverse."}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-slate-200 border border-slate-200">
        {PRACTICE_AREAS.map((p) => (
          <div
            key={p.id}
            data-testid={`practice-row-${p.id}`}
            className="bg-white p-10 lg:p-14 hover:bg-slate-50 transition-colors group"
          >
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="eyebrow">{(lang === "ar" ? p.ar : p.en).tag}</p>
                <h3 className="font-display text-3xl lg:text-4xl mt-3">
                  {(lang === "ar" ? p.ar : p.en).title}
                </h3>
              </div>
              <ArrowUpRight className="w-5 h-5 text-slate-400 shrink-0 mt-2 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform rtl:-scale-x-100" />
            </div>
            <p className="mt-6 text-slate-600 leading-relaxed max-w-xl">
              {lang === "ar" ? p.summary_ar : p.summary_en}
            </p>
            <div className="mt-8 hairline pt-6 flex items-center gap-6 text-xs text-slate-500 uppercase tracking-[0.2em]">
              <a
                href={`https://wa.me/96569656963?text=${encodeURIComponent("مرحباً، أرغب في حجز استشارة قانونية.")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-slate-900"
              >
                {t.nav.bookConsult}
              </a>
              <Link to="/contact" className="hover:text-slate-900">
                {t.nav.contact}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
